define(function riqChildFormToastrConfig() {
  return {
    applicationError: {
      type: 'error',
      title: '',
      message: 'Application Error',
      options: {}
    },
    addChildSuccess: {
      type: 'success',
      title: '',
      message: 'You successfully created a child profile!',
      options: {}
    },
    addChildSkipPlacement: {
      type: 'success',
      title: '',
      message: 'Go to My Shelf > Parent Section to take the assessment later.',
      options: {}
    },
    addChildError: {
      type: 'error',
      title: '',
      message:
        'There was an error in creating the child profile. Please try again.',
      options: {}
    },
    editChildSuccess: {
      type: 'success',
      title: '',
      message: 'You successfully updated the child profile!',
      options: {}
    },
    editChildError: {
      type: 'error',
      title: '',
      message:
        'There was an error in updating the child profile. Please try again.',
      options: {}
    },
    deleteChildSuccess: {
      type: 'success',
      title: '',
      message: 'You successfully deleted the child profile!',
      options: {}
    },
    deleteChildError: {
      type: 'error',
      title: '',
      message:
        'There was an error in deleting the child profile. Please try again.',
      options: {}
    },
    getProfileError: {
      type: 'error',
      title: '',
      message:
        'There was an error in finding the child profile. Please try again.',
      options: {}
    },
    groupSizeLimitError: {
      type: 'error',
      title: '',
      message: 'You have reached the limit of the number of profiles allowed.',
      options: {}
    },
    badWordsError: {
      type: 'error',
      title: '',
      message: 'Improper language. Please try again.',
      options: {}
    }
  };
});
